import { useField, useFormikContext } from "formik";

import { useFormContext } from "../FormContext";
import { useFieldContext } from "../FormFieldContext";
import { useFieldLabelAndDescription } from "./helpers";
import { ToggleButtonGroupControl, type ToggleButtonGroupControlProps } from "./ToggleButtonGroupControl";

type Props = Pick<ToggleButtonGroupControlProps, "options" | "orientation" | "disabled">;

export const FieldToggleButtonGroup = ({ options, ...props }: Props) => {
  const { controlId, dataTest, name } = useFieldContext();
  const { submitOnBlur } = useFormContext();
  const { submitForm } = useFormikContext();
  const [{ value }, , { setValue }] = useField<string>(name);

  const [label] = useFieldLabelAndDescription(name);

  const handleChange = (next: string) => {
    void setValue(next);
    if (submitOnBlur) {
      void submitForm();
    }
  };

  return (
    <ToggleButtonGroupControl
      options={options}
      value={value}
      onChange={handleChange}
      label={label}
      controlId={controlId}
      dataTest={dataTest}
      {...props}
    />
  );
};
